import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-28 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-violet-950 to-fuchsia-950">
        <div className="absolute inset-0" style={{ backgroundImage: "radial-gradient(ellipse at 20% 50%, rgba(139,92,246,0.3) 0%, transparent 60%), radial-gradient(ellipse at 80% 50%, rgba(217,70,239,0.25) 0%, transparent 60%)" }} />
      </div>

      {/* Decorative orbs */}
      <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-violet-500/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-fuchsia-500/15 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 border border-white/20 text-white/80 text-xs font-medium mb-8">
          <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
          Hundreds of Skool Groups growing on autopilot right now
        </div>

        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Your Skool Group Deserves<br />
          <span className="bg-gradient-to-r from-violet-400 via-fuchsia-400 to-pink-400 bg-clip-text text-transparent">
            More Members
          </span>
        </h2>

        <p className="text-lg text-white/65 mb-10 max-w-2xl mx-auto leading-relaxed">
          Stop manually posting to social media. Let ClickSendAI&apos;s AI create and publish content across 30+ Social, Video &amp; Image Sites &amp; Directories including Business Groups &amp; Directories — Automatically for You!
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <Link
            to="/get-started"
            className="group px-10 py-4 rounded-full bg-white text-violet-700 font-bold text-base hover:bg-violet-50 transition-all whitespace-nowrap cursor-pointer shadow-2xl flex items-center gap-2"
          >
            Start Free 7-Day Trial
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </Link>
          <Link
            to="/features"
            className="px-10 py-4 rounded-full border-2 border-white/25 text-white font-semibold text-base hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
          >
            Explore All Features
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6">
          {[
            { icon: "ri-check-line", text: "7-day free trial" },
            { icon: "ri-check-line", text: "Cancel anytime" },
            { icon: "ri-check-line", text: "Setup in 5 minutes" },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-1.5 text-white/55 text-sm">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${item.icon} text-emerald-400 text-sm`}></i>
              </div>
              {item.text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
